<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Tracking says delivered but I haven’t received it</h1>
			<div v-if="!loading">
				<div v-if="!shipped">
				<p class="h-text-2">
					The item has not yet shipped, when it does you will be sent tracking.
				</p>
				<email-form
						caption="Email us"
						subject="Tell me when my item will ship"
						body="My item has not yet shipped, can you tell me when it will ship?"
						on-success-url="/help?#/submitted"
						edit-body
						:payload="{ order_line_id }"
						destination-key="cs"
				></email-form>
				</div>
				<div v-else>
					<div v-if="condition !== 'marketplace'">
						<div>
							<div v-if="!submitted">
								<v-btn color="#7DADED" large round dark class="mb-3" @click="requestReplacement">Request a replacement</v-btn>
							</div>

							<p v-else-if="error">
								{{ error }}
							</p>
							<p v-else>
								We have submitted a request for a replacement copy to be sent to you and you will receive a confirmation when it is issued.
								<span v-if="tracking !== 'none available' && carrier != 'Virtual'"> Please contact {{ carrier }} and file a missing mail claim for your original package<span v-if="tracking"> referencing tracking {{ tracking }}</span>.</span>
							</p>
						</div>
					</div>
					<div v-else>
						<p>
							Please <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">message your
							seller</a>
							and let them know there was an issue
						</p>

						<p v-if="!spoke_to_seller">
							<v-btn @click="spoke_to_seller = true">I already messaged the seller and got no response</v-btn>
						</p>

						<email-form
								caption="Contact Us"
								v-if="spoke_to_seller"
								subject="Tracking says my marketplace item is delivered, but I haven’t received it"
								body="I already messaged the seller and got no response"
								on-success-url="/help?#/submitted"
								edit-body
								:payload="{ order_line_id }"
								destination-key="cs"
						></email-form>
					</div>
				</div>
			</div>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import Axios from 'axios';
	import EmailForm from './../../../components/EmailForm';

	export default {
		name: "TrackingSaysDelivered",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				submitted: false,
				spoke_to_seller: false,
				carrier: 'your carrier',
				order_line_id: null,
				condition: null,
				tracking: null,
				error: null,
				shipped: false
			};
		},

		methods: {
			requestReplacement() {
				const self = this;
				self.loading = true;

				Axios.post('/service/customer_help/rest/index.php/customer_help/send_havent_received_item_cs_request/', {
					order_line_id: parseInt(self.$route.params.id),
				})
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							self.submitted = true;

							if (response.data['data']['is_cs_request_sent']) {
								self.carrier = response.data['data']['carrier'];
								self.tracking = response.data['data']['tracking_number'];
								self.error = null;
							} else {
								self.error = response.data['data']['message'];
							}
						}
					})
					.finally(function () {
						self.loading = false;
					});
			}
		},

		mounted() {
			const self = this;
			self.loading = true;
			self.order_line_id = parseInt(self.$route.params.id);

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.condition = response.data['data']['product_type'];
						self.shipped = response.data['data']['shipped'] > 0;
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},
	}
</script>

<style scoped>

</style>